import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getFootprintingCropFootprintByPrimaryDataIdAdmin, getFootprintingCropPrimaryDataById } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_CROP_PRIMARY_DATA } from "consts";

export const useGetFootprintingCropPrimaryDataById = (primaryDataId: string) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useQuery(
    {
      queryKey: [FOOTPRINTING_CROP_PRIMARY_DATA, primaryDataId, isAdmin],
      queryFn: async () => {
        if (isAdmin) {
          return (await getFootprintingCropFootprintByPrimaryDataIdAdmin(primaryDataId)).footprint;
        }
        return getFootprintingCropPrimaryDataById(primaryDataId);
      },
      enabled: !!primaryDataId,
      gcTime: 60000,
    },
    queryClient
  );
};
